export interface ILineHeaderProps {
  typeHeader: ELineHeaderTypes
}

export enum ELineHeaderTypes {
  LINE = 'line',
  LIVE = 'live',
  TOURNAMENTS = 'tournament'
}
